import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Filtri ")
const _hoisted_2 = {
  key: 0,
  class: "badge"
}
const _hoisted_3 = {
  key: 1,
  class: "material-icons"
}
const _hoisted_4 = { class: "modal-content p-mb-6" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "Data del pagamento", -1)
const _hoisted_6 = { class: "p-d-flex p-ai-center gap-8" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 1M ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 2M ")
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "Data della prenotazione", -1)
const _hoisted_10 = { class: "p-d-flex p-ai-center gap-8" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 1M ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 2M ")
const _hoisted_13 = { class: "flexbox-row" }

import { computed, reactive, ref, watch, readonly, nextTick } from 'vue';
import UiButton from '../ui/UiButton.vue';
import { PaymentFilters } from '@/api/types';
import { useI18n } from 'vue-i18n';
import UsersSearch from '../users-search/UsersSearch.vue';
import { PadelUser } from '@/models/user.models';
import moment from 'moment';
import PadelCalendar from '@/widgets/calendar/PadelCalendar.vue';


export default _defineComponent({
  props: {
    filters: { type: null, required: true }
  } as unknown as undefined,
  emits: ["update:filters"] as unknown as undefined,
  setup(__props: {
  filters: PaymentFilters;
}, { emit }: { emit: ({
  (e: 'update:filters', f: typeof currentFilters): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props
const { t } = useI18n();
const isVisible = ref(false);
const appliedFilters = ref(0);
const paymentDateFrom = ref<Date>();
const paymentDateTo = ref<Date>();
const bookingDateFrom = ref<Date>();
const bookingDateTo = ref<Date>();



const currentFilters = reactive<PaymentFilters>({ ...props.filters })
const userSelected = ref<PadelUser>()




const currentFiltersNumber = computed(() => Object.values(currentFilters).filter(el => !!el).length)

const bookingState = readonly([
  { value: "CANCELLED", label: "Cancellate" },
  { value: "CONFIRMED", label: "Confermate" }
]);

const paymentStateOptions = readonly([
  { value: "ELABORATED", label: "Completi e Falliti" },
  { value: "COMPLETED", label: "Completi" },
  { value: "FAILED", label: "Falliti" },
  { value: "SCHEDULED", label: "Programmati" },
  { value: "CANCELLED", label: "Cancellati" }
])

const applyFilters = () => {
  emit('update:filters', {
    ...currentFilters,
    bookingStatus: currentFilters.bookingStatus === 'ALL' ? undefined : currentFilters.bookingStatus
  });
  appliedFilters.value = currentFiltersNumber.value;
  isVisible.value = false;
}

const resetFilters = () => {
  bookingDateFrom.value = undefined;
  bookingDateTo.value = undefined;
  paymentDateFrom.value = undefined;
  paymentDateTo.value = undefined;
  currentFilters.bookingStatus = undefined;
  currentFilters.paymentStatus = undefined;
  currentFilters.userId = undefined;
  currentFilters.bookingStatus = undefined;
  userSelected.value = undefined;
  nextTick(() => {
    emit('update:filters', { ...currentFilters });
    appliedFilters.value = currentFiltersNumber.value;
    isVisible.value = false;
  })
}

const setUser = (user: PadelUser) => {
  userSelected.value = user;
  currentFilters.userId = user.id;
}

const setPaymentDateInterval = (months: number) => {
  const today = moment();
  const monthsAgo = today.clone().subtract(months, 'month');
  paymentDateFrom.value = monthsAgo.toDate();
  paymentDateTo.value = today.toDate();
}

const setBookingDateInterval = (months: number) => {
  const today = moment();
  const monthsAgo = today.clone().subtract(months, 'month');
  bookingDateTo.value = today.toDate();
  bookingDateFrom.value = monthsAgo.toDate();
}

watch(
  [paymentDateFrom, paymentDateTo, bookingDateFrom, bookingDateTo],
  (newValues, oldValues) => {
    const dateMap: { key: 'paymentDateFrom' | 'paymentDateTo' | 'bookingDateFrom' | 'bookingDateTo'; value: Date }[] = [
      { key: 'paymentDateFrom', value: newValues[0] },
      { key: 'paymentDateTo', value: newValues[1] },
      { key: 'bookingDateFrom', value: newValues[2] },
      { key: 'bookingDateTo', value: newValues[3] },
    ]
    dateMap.forEach((item, index) => {
      if (item.value !== oldValues[index]) {
        currentFilters[item.key] = item.value ? moment(item.value).format('YYYY-MM-DD') : undefined
      }
    })
  }, { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_PadelDropdown = _resolveComponent("PadelDropdown")!
  const _component_DumbModal = _resolveComponent("DumbModal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(UiButton, {
      onClick: _cache[1] || (_cache[1] = () => isVisible.value = true),
      variant: !appliedFilters.value ? 'primary' : 'danger'
    }, {
      "right-icon": _withCtx(() => [
        (appliedFilters.value)
          ? (_openBlock(), _createBlock("span", _hoisted_2, _toDisplayString(appliedFilters.value), 1))
          : (_openBlock(), _createBlock("i", _hoisted_3, "filter_list"))
      ]),
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["variant"]),
    (isVisible.value)
      ? (_openBlock(), _createBlock(_component_DumbModal, {
          key: 0,
          onHide: _cache[13] || (_cache[13] = () => isVisible.value = false),
          title: _unref(t)('filter_payments')
        }, {
          footer: _withCtx(() => [
            _createVNode("div", _hoisted_13, [
              _createVNode(UiButton, {
                onClick: _cache[12] || (_cache[12] = () => isVisible.value = false),
                "is-text": "",
                size: "lg",
                class: "uppercase"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('abort')), 1)
                ]),
                _: 1
              }),
              _createVNode(UiButton, {
                onClick: resetFilters,
                "is-text": "",
                size: "lg",
                class: "p-ml-auto uppercase"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('reset_filters')), 1)
                ]),
                _: 1
              }),
              _createVNode(UiButton, {
                onClick: applyFilters,
                size: "lg",
                class: "p-ml-4 uppercase"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('apply')), 1)
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode("div", _hoisted_6, [
                _createVNode(PadelCalendar, {
                  label: _unref(t)('rule_from'),
                  value: paymentDateFrom.value,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (paymentDateFrom.value = $event))
                }, null, 8, ["label", "value"]),
                _createVNode(PadelCalendar, {
                  label: _unref(t)('rule_to'),
                  value: paymentDateTo.value,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (paymentDateTo.value = $event))
                }, null, 8, ["label", "value"]),
                _createVNode(UiButton, {
                  onClick: _cache[4] || (_cache[4] = () => setPaymentDateInterval(1)),
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }),
                _createVNode(UiButton, {
                  onClick: _cache[5] || (_cache[5] = () => setPaymentDateInterval(2)),
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                })
              ]),
              _hoisted_9,
              _createVNode("div", _hoisted_10, [
                _createVNode(PadelCalendar, {
                  label: _unref(t)('rule_from'),
                  value: bookingDateFrom.value,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (bookingDateFrom.value = $event))
                }, null, 8, ["label", "value"]),
                _createVNode(PadelCalendar, {
                  label: _unref(t)('rule_to'),
                  value: bookingDateTo.value,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (bookingDateTo.value = $event))
                }, null, 8, ["label", "value"]),
                _createVNode(UiButton, {
                  onClick: _cache[8] || (_cache[8] = () => setBookingDateInterval(1)),
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }),
                _createVNode(UiButton, {
                  onClick: _cache[9] || (_cache[9] = () => setBookingDateInterval(2)),
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                })
              ]),
              _createVNode(UsersSearch, {
                onUserSelected: setUser,
                "search-user": userSelected.value
              }, null, 8, ["search-user"]),
              _createVNode(_component_PadelDropdown, {
                label: _unref(t)('stato_prenotazione'),
                options: _unref(bookingState),
                default: _unref(currentFilters).bookingStatus,
                "onUpdate:default": _cache[10] || (_cache[10] = ($event: any) => (_unref(currentFilters).bookingStatus = $event))
              }, null, 8, ["label", "options", "default"]),
              _createVNode(_component_PadelDropdown, {
                label: _unref(t)('payment'),
                options: _unref(paymentStateOptions),
                default: _unref(currentFilters).paymentStatus,
                "onUpdate:default": _cache[11] || (_cache[11] = ($event: any) => (_unref(currentFilters).paymentStatus = $event))
              }, null, 8, ["label", "options", "default"])
            ])
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})